<template>
    <div id="direct-connect-interface">
        <call-modal v-show="started"></call-modal>
    </div>
</template>

<script>
    import Cookie from 'js-cookie';
    import { mapGetters } from 'vuex';
    import state from './store/state';
    import _forEach from 'lodash/forEach';

    export default {
        props: {
            lead: {
                type: Object,
                required: true
            },

            tenant: {
                type: Object,
                required: true
            },

            directConnect: {
                type: Object,
                required: true
            }
        },

        created() {
            if (! this.$store.hasModule('call')) {
                this.$store.registerModule('call', state);
            }
        },

        mounted() {
            this.$store.commit('lead', this.lead);
            this.$store.commit('tenant', this.tenant);
            this.$store.commit('directConnect', this.directConnect);

            this.$event.$on('cancel-call', this.cancelCall);
            this.$event.$on('retry-call', this.makeCall);
            this.$event.$on('start-call', this.makeCall);

            if (this.canStartDirectConnect) {
                this.showModal();
            }
        },

        computed: {
            canStartDirectConnect() {
                return this.tenant.integrations.direct_connect;
            },

            ...mapGetters([
                'hasScheduledCall',
                'started',
                'hasCalendly',
            ])
        },

        methods: {
            cancelCall() {
                this.$http.delete(route('api.direct-connect.destroy', this.$store.getters.sid))
                    .then(() => {
                        this.modal(this.hasCalendly ? 'schedule-appointment' : 'lead-choice');
                    });
            },

            makeCall() {
                this.modal('lead-initiated');
                this.$store.commit('started', true);

                this.$http.post(route('api.direct-connect.store', this.lead.hash))
                    .then(({data}) => {
                        // Set a cookie to ensure the lead isn't called a second time.
                        Cookie.set('leadHash', this.lead.hash, { expires: 7 });

                        this.$store.commit('sid', data.sid);

                        let channel = Echo.channel(`call.${data.sid}`);

                        _forEach(this.$store.getters.events, event => {
                            channel.listen(event, ({component}) => this.modal(component));
                        });
                    })
                    .catch(error => {
                        this.modal('lead-failed');
                        bugsnagClient.notify(error);
                    });
            },

            modal(component) {
                this.$store.commit('modal', component);
            },

            showModal() {
                this.hasScheduledCall
                    ? this.modal('schedule-appointment')
                    : this.modal('lead-choice');

                this.$store.commit('started', true);
            }
        }
    }
</script>
